<template>
    <!-- IE 2026 10 25 / ODOO-348925 (заказ Игоря: ERD-вид схемы): вкладка «ERD» группы «Поля» — AttrSchemeGraph с params view 'erd' (бэк main 71b8d5d9f, scheme_erd()).
         Inline SVG по эталону ie-dm7 erd-ref (gen.py / erd.html): смуги групп, карточки узлов с полями, линии поле ↔ поле по рёбрам doc.edges, чипы внешних источников,
         легенда внизу. Модель — utils/schemeGraphErd.js (sgeModel), связь с гридами — utils/schemeGraphGrid.js (копия логики графа v2). Правки нет (editable false).
         Клик по заголовку карточки / строке поля / линии / чипу / заголовку смуги выделяет строку грида (nodes / node_fields + fields / edges), выбор строки в гриде
         подсвечивает карточку / строки / линии. Карточка наведения — только Alt / «Show tooltips». Выключатель fe.ux.schemeGraphErd (дефолт ВКЛ; выкл — обычный граф) -->
    <div class="attr-sge" ref="host" v-if="attr" @mouseenter="hookGrids">
        <div v-if="notice" class="sge-notice">{{ notice }}</div>
        <template v-else>
            <div class="sge-head">
                <span class="sge-stats" v-if="model">{{ statsText }}</span>
                <span class="sge-hint">{{ t('Click a card, a field, a line or a chip to select its row') }}</span>
                <button type="button" class="sge-btn" v-if="model && model.W > width" @click.stop="fitOn = !fitOn">
                    <i :class="fitOn ? 'pi pi-search-plus' : 'pi pi-arrows-h'"></i><span>{{ fitOn ? t('Actual size') : t('Fit to width') }}</span></button>
            </div>
            <div v-if="warn" class="sge-warn">{{ warn }}</div>
            <div class="sge-scroll">
                <svg v-if="model" ref="svg" class="sge-svg" :class="{ 'sge-any': hl.any }" :viewBox="'0 0 ' + model.W + ' ' + model.H" :width="box.w" :height="box.h"
                    preserveAspectRatio="xMinYMin meet" @click="clearSel" @mouseleave="hover = null">
                    <defs>
                        <!-- IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): наконечник — остриё на конце пути d, линия (dl) кончается внутри него (refX = len − trim): на увеличении конец острый -->
                        <template v-for="mk in markers" :key="mk.id">
                            <marker :id="mk.id + '-a'" markerUnits="userSpaceOnUse" markerWidth="10" markerHeight="10" :refX="ARROW.len - ARROW.trim" refY="5" orient="auto" overflow="visible"><path d="M0,0.5 L9,5 L0,9.5 Z" :fill="mk.color" /></marker>
                            <marker :id="mk.id + '-d'" markerUnits="userSpaceOnUse" markerWidth="8" markerHeight="8" refX="4" refY="4"><circle cx="4" cy="4" r="3" fill="#FFFFFF" :stroke="mk.color" stroke-width="1.5" /></marker>
                        </template>
                    </defs>
                    <!-- смуги групп: тон цвета группы, заголовок прописными (клик — строка группы в гриде узлов), справа — число узлов -->
                    <g v-for="b in model.bands" :key="'b' + b.gid" class="sge-band" :class="{ 'sge-hl': hl.bands.has(b.gid) }">
                        <rect :x="b.x" :y="model.top - S.bandHead" :width="b.w" :height="model.contentBottom - model.top + S.bandHead + 12" rx="10" :fill="b.tint" />
                        <text class="sge-band-t" :x="b.x + 16" :y="model.top - 14" :fill="b.titleInk" @click.stop="pickGroup(b)">{{ b.titleText }}</text>
                        <text class="sge-band-n" :x="b.x + b.w - 16" :y="model.top - 14" text-anchor="end" :fill="b.titleInk">{{ b.countText }}</text>
                    </g>
                    <!-- линии поле ↔ поле (под карточками: концы — у краёв карточек), выделенные — последними -->
                    <g v-for="l in linesOrdered" :key="l.id" class="sge-line" :class="{ 'sge-sel': hl.links.has(l.id), 'sge-off': !l.use }"
                        @click.stop="pickLine(l)" @mouseenter="onHover('line', l, $event)" @mousemove="onMove($event)" @mouseleave="hover = null">
                        <path class="sge-hit" :d="l.d" />
                        <path class="sge-path" :d="l.dl || l.d" :stroke="l.color" :stroke-width="hl.links.has(l.id) ? l.width + 1.2 : l.width" :stroke-dasharray="l.dash || null" :stroke-linecap="l.cap || 'butt'"
                            :marker-start="'url(#' + mid(l.color) + '-d)'" :marker-end="'url(#' + mid(l.color) + '-a)'" />
                    </g>
                    <g v-for="ch in model.chips" :key="'cl' + ch.id" class="sge-line" :class="{ 'sge-sel': hl.chips.has(ch.id) }" @click.stop="pickChip(ch)">
                        <path class="sge-hit" :d="ch.d" />
                        <path class="sge-path" :d="ch.dl || ch.d" :stroke="ch.color" :stroke-width="hl.chips.has(ch.id) ? ch.width + 1.2 : ch.width" :stroke-dasharray="ch.dash || null" :stroke-linecap="ch.cap || 'butt'" :marker-end="'url(#' + mid(ch.color) + '-a)'" />
                    </g>
                    <g v-for="lb in model.labels" :key="'lg' + lb.edge" class="sge-lag" :class="{ 'sge-dim': hl.any && !edgeHl(lb.edge) }">
                        <text :x="lb.x" :y="lb.y - 3" :text-anchor="lb.anchor" :fill="lb.color">{{ lb.a }}<tspan :x="lb.x" dy="13" class="sge-lag2">{{ lb.b }}</tspan></text>
                    </g>
                    <!-- карточки: заголовок (клик — строка узла), вид, пилюли горизонтов; строки — поля узла (клик — строка «Вузли + Поля» и поле в «Поля») -->
                    <!-- IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): разметка карточки — graph/SchemeErdCard.vue (общая с видом «Картки» графа схемы) -->
                    <SchemeErdCard v-for="c in model.cards" :key="'c' + c.id" :c="c" :x="c.x" :y="c.y" :hl="hl.cards.has(c.id)" :hl-rows="hl.rows" :dim="hl.any && !cardLit(c)" interactive
                        @pick-head="pickNode" @pick-row="pickRow" @hover="onHover" @move="onMove" @leave="hover = null" />
                    <!-- чипы внешних источников (рёбра без source): мера, горизонт, текст ребра -->
                    <g v-for="ch in model.chips" :key="'ch' + ch.id" class="sge-chip" :class="{ 'sge-hl': hl.chips.has(ch.id), 'sge-dim': hl.any && !hl.chips.has(ch.id) }"
                        @click.stop="pickChip(ch)" @mouseenter="onHover('chip', ch, $event)" @mousemove="onMove($event)" @mouseleave="hover = null">
                        <rect :x="ch.x" :y="ch.y" :width="ch.w" :height="ch.h" rx="5" fill="#FFFFFF" stroke="#9E9E9E" stroke-width="1" stroke-dasharray="4 3" />
                        <text class="sge-mono" :x="ch.x + 8" :y="ch.y + 14" :fill="INK">{{ ch.mText }}</text>
                        <text class="sge-chiphz" :x="ch.x + ch.w - 8" :y="ch.y + 14" text-anchor="end" :fill="MUTED">{{ ch.hz }}</text>
                        <text class="sge-chiptxt" :x="ch.x + 8" :y="ch.y + 27" :fill="MUTED">{{ ch.tText }}</text>
                    </g>
                    <!-- легенда (как эталон): виды связей схемы и образец чипа; глифы ролей полей; примечание — теги, пилюли, правило связей полей -->
                    <g class="sge-legend">
                        <text class="sge-leghead" :x="model.legend.x0" :y="model.legend.y" :fill="INK">{{ model.legend.headLinks }}</text>
                        <g v-for="k in model.legend.items" :key="'k' + k.id">
                            <path :d="'M' + k.x + ',' + (model.legend.y - 4) + ' L' + (k.x + 46 - ARROW.trim) + ',' + (model.legend.y - 4)" :stroke="k.color" :stroke-width="k.width" :stroke-dasharray="k.dash || null" fill="none"
                                :marker-start="'url(#' + mid(k.color) + '-d)'" :marker-end="'url(#' + mid(k.color) + '-a)'" />
                            <text class="sge-leg" :x="k.x + 54" :y="model.legend.y" :fill="INK">{{ k.title }}</text>
                        </g>
                        <g v-if="model.legend.chip">
                            <rect :x="model.legend.chip.x" :y="model.legend.y - 12" width="44" height="16" rx="4" fill="#FFFFFF" stroke="#9E9E9E" stroke-dasharray="4 3" />
                            <text class="sge-mono sge-mono-s" :x="model.legend.chip.x + 22" :y="model.legend.y" text-anchor="middle" :fill="INK">{{ model.legend.chip.sample }}</text>
                            <text class="sge-leg" :x="model.legend.chip.x + 52" :y="model.legend.y" :fill="INK">{{ model.legend.chip.title }}</text>
                        </g>
                        <text class="sge-leghead" :x="model.legend.x0" :y="model.legend.y + S.legendRow" :fill="INK">{{ model.legend.headFields }}</text>
                        <g v-for="f in model.legend.fields" :key="'f' + f.glyph">
                            <text class="sge-glyph" :x="f.x" :y="model.legend.y + S.legendRow" :fill="MUTED">{{ f.glyph }}</text>
                            <text class="sge-leg" :x="f.x + 14" :y="model.legend.y + S.legendRow" :fill="INK">{{ f.title }}</text>
                        </g>
                        <text v-for="(n, i) in model.legend.notes" :key="'n' + i" class="sge-note" :x="model.legend.x0" :y="model.legend.y + 2 * S.legendRow + i * S.noteRow" :fill="MUTED">{{ n }}</text>
                    </g>
                </svg>
            </div>
            <!-- карточка наведения: только Alt / Show tooltips (правило Игоря: по наведению ничего не всплывает) -->
            <div class="sge-tip" v-if="hover && tipOn" :style="tipStyle">
                <template v-if="hover.type === 'line'">
                    <div class="sge-tip-title">{{ cardTitle(hover.item.src) }} → {{ cardTitle(hover.item.dst) }}</div>
                    <div class="sge-tip-row" v-if="!hover.item.head">{{ fieldTitle(hover.item.src, hover.item.sfield) }} → {{ fieldTitle(hover.item.dst, hover.item.dfield) }}</div>
                    <div class="sge-tip-row" v-if="hover.item.kindTitle"><span class="sge-tip-k">{{ t('Link kind') }}:</span> {{ hover.item.kindTitle }}</div>
                    <div class="sge-tip-row" v-if="hover.item.title">{{ hover.item.title }}</div>
                    <div class="sge-tip-row sge-tip-muted" v-if="hover.item.conv">{{ t('No measure of the same name: the first measure of the source → the first measure of the target') }}</div>
                    <div class="sge-tip-row sge-tip-muted" v-if="hover.item.head">{{ t('The linked nodes have no fields in common: the line joins the cards') }}</div>
                </template>
                <template v-else-if="hover.type === 'row'">
                    <div class="sge-tip-title">{{ hover.item.r.title }}</div>
                    <div class="sge-tip-row"><span class="sge-tip-k">{{ t('Node') }}:</span> {{ hover.item.c.title }} · {{ hover.item.r.field }}</div>
                    <div class="sge-tip-row" v-if="hover.item.r.tag"><span class="sge-tip-k">{{ t('Dimension role') }}:</span> {{ hover.item.r.tag }}</div>
                    <div class="sge-tip-row sge-tip-muted" v-if="!hover.item.r.use">{{ t('Switched off') }}</div>
                </template>
                <template v-else-if="hover.type === 'chip'">
                    <div class="sge-tip-title">{{ hover.item.measure }}</div>
                    <div class="sge-tip-row" v-if="hover.item.text">{{ hover.item.text }}</div>
                    <div class="sge-tip-row" v-if="hover.item.hzTitle"><span class="sge-tip-k">{{ t('Horizon') }}:</span> {{ hover.item.hzTitle }}</div>
                    <div class="sge-tip-row" v-if="hover.item.kindTitle"><span class="sge-tip-k">{{ t('Link kind') }}:</span> {{ hover.item.kindTitle }}</div>
                    <div class="sge-tip-row sge-tip-muted">{{ t('External source (no node): attached to a measure of {node}', { node: cardTitle(hover.item.dst) }) }}</div>
                </template>
                <template v-else>
                    <div class="sge-tip-title">{{ hover.item.title }}</div>
                    <div class="sge-tip-row" v-if="hover.item.kind"><span class="sge-tip-k">{{ t('Kind') }}:</span> {{ hover.item.kind }}</div>
                    <div class="sge-tip-row" v-if="hover.item.pills.length"><span class="sge-tip-k">{{ t('Horizons') }}:</span> {{ hover.item.pills.map((p) => p.title).join(', ') }}</div>
                    <div class="sge-tip-row sge-tip-muted" v-if="!hover.item.use">{{ t('Switched off') }}</div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: ERD-вид схемы): см. шаблон. Монтирует AttrSchemeGraphV2 при view 'erd' (патч p036b): attr — по attr_id без реестра attrs_vueObj
// (реестр остаётся за V2), строки — табличные части записи (только чтение), модель — sgeModel, перерасчёт — при смене строк / языка / шрифта / цветов
import { toRaw } from 'vue'
import { useMainStore } from '@/stores/mainStore'
import { t, tn } from '@/i18n'
import altTooltip from '@/utils/altTooltip'
import { getPath, keyOf } from '@/utils/schemeGraph'
import { sg2RowKey, sg2FitBox, sg2ColorsOn } from '@/utils/schemeGraphV2'
import { SGE, SGE_INK, SGE_MUTED, sgeConfig, sgeModel, sgeHighlight, sgeNfKey, sgeFieldName } from '@/utils/schemeGraphErd'
import { SGE_ARROW, sgeCanvasMeasure } from '@/utils/schemeGraphErd'   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов)
import SchemeErdCard from './graph/SchemeErdCard.vue'   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов)
import { sggLink, sggItems, sggIndexOf, sggGridPosOf, sggPosOfKey } from '@/utils/schemeGraphGrid'

let UID = 0
// шрифты подписей — utils/schemeGraphErd.js SGE_CANVAS_FONTS (IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): общий замер с видом «Картки» графа)

function stats() {
    if (typeof window === 'undefined') return {}
    return (window.__sgeStats = window.__sgeStats || { models: 0, ms: 0, picks: 0, gridPicks: 0, pending: 0, cards: 0, lines: 0, chips: 0 })
}

export default {
    name: 'AttrSchemeGraphErd',
    components: { SchemeErdCard },   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов)
    props: { widget_id: [String, Number], attr_id: String },
    data: () => ({ WIDGET: {}, attr: null, parent_attr: null, width: 0, sel: null, hover: null, tipPos: { x: 0, y: 0 }, fitOn: false, fontEpoch: 0, colorsOn: true }),
    setup() { return { store: useMainStore(), S: SGE, INK: SGE_INK, MUTED: SGE_MUTED, ARROW: SGE_ARROW } },   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): + ARROW
    created() {
        this._sgeId = 'sge' + (++UID)
        this._ctx = null; this._fam = ''
        this._measure = sgeCanvasMeasure(() => { if (!this._ctx) this._ctx = document.createElement('canvas').getContext('2d'); return this._ctx }, () => this._fam)   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.store.widget_attr_set(this, false)   // attr по id; реестр attrs_vueObj — за обёрткой (AttrSchemeGraphV2)
        this.colorsOn = sg2ColorsOn((k, d) => this.store.setting(k, d))
        this._link = sggLink({
            names: () => ({ edges: this.cfg.edges_grid_name, nodes: this.cfg.nodes_grid_name, nf: this.cfg.node_fields_grid_name, fields: this.cfg.fields_grid_name }),
            widget: () => this.WIDGET, sel: () => this.sel, dead: () => !!this._dead, stats,
            onPick: (which, item, flex) => this.fromGrid(which, item, flex),
        })
    },
    mounted() {
        this.measure()
        this.refont()
        try { document.fonts?.ready?.then(() => { if (!this._dead) this.refont(true) }) } catch (e) { /* нет FontFaceSet */ }
        try { this._ro = new ResizeObserver(() => { if (this._raf) return; this._raf = requestAnimationFrame(() => { this._raf = 0; this.measure() }) }); if (this.$refs.host) this._ro.observe(this.$refs.host) } catch (e) { /* нет ResizeObserver */ }
        this._hookT = [0, 300, 1200, 3000].map((ms) => setTimeout(() => this.hookGrids(), ms))
    },
    unmounted() {
        this._dead = true
        if (this._ro) try { this._ro.disconnect() } catch (e) { /* уже отключён */ }
        if (this._raf) cancelAnimationFrame(this._raf)
        for (const t_ of this._hookT || []) clearTimeout(t_)
        this._link.stop()
    },
    computed: {
        cfgRes() { return sgeConfig(this.attr) },
        cfg() { return this.cfgRes.cfg },
        record() { return this.WIDGET?.record || null },
        nodesRows() { return this.rows(this.cfg.nodes_binding) },
        edgesRows() { return this.rows(this.cfg.edges_binding) },
        nfRows() { return this.rows(this.cfg.node_fields_binding) },
        fieldsRows() { return this.rows(this.cfg.fields_binding) },
        nhRows() { return this.rows(this.cfg.node_horizons_binding) },
        horizonsRows() { return this.rows(this.cfg.horizons_binding) },
        layout() { return this.record && this.cfg.layout_binding ? this.store.get_value(this.record, this.cfg.layout_binding) : null },
        notice() {
            const missing = this.cfgRes.errors.find((e) => e.code === 'missing')
            if (missing) return t('The graph is not configured: {params} missing', { params: missing.params.join(', ') })
            if (!this.nodesRows.length) return t('No nodes: the table part {binding} is empty', { binding: this.cfg.nodes_binding })
            return ''
        },
        model() {
            if (this.notice || this.fontEpoch < 0) return null
            const T0 = performance.now()
            const m = sgeModel({ nodesRows: this.nodesRows, edgesRows: this.edgesRows, nfRows: this.nfRows, fieldsRows: this.fieldsRows, nhRows: this.nhRows, horizonsRows: this.horizonsRows, layout: this.layout },
                this.cfg, { lang: this.store.get_lang(), measure: (s, f) => this.textW(s, f), colorsOn: this.colorsOn })
            const S = stats(); S.models++; S.ms = Math.round((performance.now() - T0) * 10) / 10
            if (m) { S.cards = m.cards.length; S.lines = m.stats.lines; S.chips = m.chips.length }
            return m
        },
        statsText() {
            const s = this.model?.stats
            if (!s) return ''
            return [tn(s.nodes, '{n} node', '{n} nodes'), tn(s.fields, '{n} field', '{n} fields'), t('{edges} links ({lines} field lines)', { edges: s.edges, lines: s.lines }),
                tn(s.external, '{n} external source', '{n} external sources')].join(' · ')
        },
        warn() {
            const d = this.model?.dangling || []
            return d.length ? t('{n} links refer to nodes that are not in the scheme', { n: d.length }) : ''
        },
        hl() { return sgeHighlight(this.model, this.sel) },
        linesOrdered() { const list = this.model?.links || []; return [...list].sort((a, b) => (this.hl.links.has(a.id) ? 1 : 0) - (this.hl.links.has(b.id) ? 1 : 0)) },
        markers() {
            const m = this.model
            if (!m) return []
            const set = new Map()
            for (const x of [...m.links, ...m.chips, ...m.legend.items]) if (x.color && !set.has(x.color)) set.set(x.color, { id: this.mid(x.color), color: x.color })
            return [...set.values()]
        },
        box() { return sg2FitBox(this.model, this.width, this.fitOn) },
        tipOn() {
            const epoch = this.store.altTipEpoch || 0, show = !!this.store.showTooltip
            return epoch >= 0 && (show || altTooltip.detailsOn())
        },
        tipStyle() { return { left: Math.min(this.tipPos.x + 14, Math.max(0, (this.width || 400) - 320)) + 'px', top: (this.tipPos.y + 12) + 'px' } },
    },
    watch: {
        edgesRows() { this.$nextTick(() => this.hookGrids()) },
    },
    methods: {
        t,
        rows(b) { const v = this.record && b ? this.store.get_value(this.record, b) : null; return Array.isArray(v) ? v : [] },
        mid(color) { return this._sgeId + '-' + String(color).replace(/[^a-z0-9]/gi, '') },
        measure() {
            const host = this.$refs.host
            if (!host) return
            const w = Math.floor(host.getBoundingClientRect().width) - 12
            if (w > 0 && Math.abs(w - this.width) > 1) this.width = w
        },
        refont(force) {
            let fam = ''
            try { fam = (this.$refs.host && getComputedStyle(this.$refs.host).fontFamily) || '' } catch (e) { /* нет стилей */ }
            fam = fam || 'sans-serif'
            if (force || fam !== this._fam) { this._fam = fam; this.fontEpoch++ }
        },
        // ширина подписи шрифтом SVG (canvas); без canvas — оценка по символам
        textW(s, font) { return this._measure(s, font) },   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): замер — sgeCanvasMeasure; цвета пилюль — в SchemeErdCard
        cardLit(c) {
            if (this.hl.cards.has(c.id)) return true
            for (const r of c.rows) if (this.hl.rows.has(c.id + '|' + r.field)) return true
            return false
        },
        edgeHl(i) { return (this.model?.links || []).some((l) => l.edge === i && this.hl.links.has(l.id)) },
        cardTitle(id) { const c = this.model?.cards.find((x) => x.id === id); return c ? c.title : id },
        fieldTitle(id, f) { const c = this.model?.cards.find((x) => x.id === id); const r = c && c.rows.find((x) => x.field === f); return r ? r.title : f },
        onHover(type, item, ev) { this.hover = { type, item }; this.onMove(ev) },
        onMove(ev) {
            const host = this.$refs.host
            if (!host || !ev) return
            const r = host.getBoundingClientRect()
            this.tipPos = { x: ev.clientX - r.left, y: ev.clientY - r.top }
        },
        raw(list) { return list.map((r) => toRaw(r)) },
        // ---------- выделение: картинка → грид ----------
        clearSel() { this.sel = null; this._link.clearPending() },
        pickNode(c) {
            this.sel = { node: c.id }; stats().picks++
            const kb = this.cfg.key_binding
            this._link.toGrid('nodes', (items) => sggPosOfKey(items, c.key, (r) => keyOf(getPath(r, kb))))
        },
        pickGroup(b) {
            this.sel = { group: b.gid }; stats().picks++
            const kb = this.cfg.key_binding
            if (b.key) this._link.toGrid('nodes', (items) => sggPosOfKey(items, b.key, (r) => keyOf(getPath(r, kb))))
        },
        pickRow(c, r) {
            this.sel = { nf: r.index }; stats().picks++
            const cfg = this.cfg, rows = this.raw(this.nfRows)
            this._link.toGrid('nf', (items) => sggGridPosOf(items, rows, r.index, (x) => sgeNfKey(x, cfg)))
            this._link.toGrid('fields', (items) => sggPosOfKey(items, r.field, sgeFieldName))
        },
        pickEdge(index) {
            this.sel = { edge: index }; stats().picks++
            const cfg = this.cfg, rows = this.raw(this.edgesRows)
            this._link.toGrid('edges', (items) => sggGridPosOf(items, rows, index, (x) => sg2RowKey(x, cfg)))
        },
        pickLine(l) { this.pickEdge(l.edge) },
        pickChip(ch) { this.pickEdge(ch.edge) },
        // ---------- выделение: грид → картинка ----------
        hookGrids() { if (!this._dead) this._link.hookAll() },
        fromGrid(which, item, flex) {
            if (!item) { this.sel = null; return }
            const cfg = this.cfg
            if (which === 'edges') {
                const i = sggIndexOf(this.raw(this.edgesRows), item, (x) => sg2RowKey(x, cfg), sggItems(flex))
                this.sel = i >= 0 ? { edge: i } : null
            } else if (which === 'nf') {
                const i = sggIndexOf(this.raw(this.nfRows), item, (x) => sgeNfKey(x, cfg), sggItems(flex))
                this.sel = i >= 0 ? { nf: i } : null
            } else if (which === 'fields') {
                const f = sgeFieldName(item)
                this.sel = f ? { field: f } : null
            } else {
                const key = keyOf(getPath(item, cfg.key_binding))
                const c = this.model?.cards.find((x) => x.key === key)
                const b = c ? null : this.model?.bands.find((x) => x.key === key)
                this.sel = c ? { node: c.id } : b ? { group: b.gid } : null
            }
        },
    },
}
</script>

<style>
/* IE 2026 10 25 / ODOO-348925 (заказ Игоря: ERD-вид схемы): вид — эталон ie-dm7 erd-ref (смуги тоном группы, карточки с рамкой цветом, пилюли, теги, чипы пунктиром) */
.attr-sge { position: relative; padding: 4px 6px 2px; --sge-hl: var(--orange-500, #f59e0b); }
.sge-head { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; font-size: 12px; color: var(--text-color-secondary); margin-bottom: 2px; min-height: 22px; }
.sge-hint { margin-left: auto; opacity: .75; }
.sge-btn { display: inline-flex; align-items: center; gap: 4px; padding: 1px 8px; font-size: 11.5px; line-height: 16px; color: var(--text-color, #2b3a4a); background: var(--surface-card, #fff); border: 1px solid var(--surface-border, #b9c8dd); border-radius: 4px; cursor: pointer; }
.sge-btn:hover { background: var(--surface-hover, #eef3fb); }
.sge-notice, .sge-warn { padding: 8px 12px; color: var(--text-color-secondary, #6b7280); }
.sge-warn { font-size: 0.9em; padding: 2px 6px; }
.sge-scroll { overflow: auto; max-width: 100%; }
.sge-svg { display: block; background: #FFFFFF; user-select: none; }
.sge-band-t { font-size: 12px; font-weight: 700; letter-spacing: 1.4px; cursor: pointer; }
.sge-band-n { font-size: 11px; font-weight: 500; letter-spacing: 0.3px; }
.sge-band.sge-hl rect { stroke: var(--sge-hl); stroke-width: 2; }
.sge-line { cursor: pointer; }
.sge-line .sge-hit { fill: none; stroke: transparent; stroke-width: 10; }
.sge-line .sge-path { fill: none; }
.sge-line.sge-off { opacity: .4; }
.sge-any .sge-line:not(.sge-sel) { opacity: .16; }
.sge-any .sge-line:not(.sge-sel):hover { opacity: .6; }
.sge-lag text { font-size: 11px; font-weight: 600; paint-order: stroke; stroke: #FFFFFF; stroke-width: 3px; stroke-linejoin: round; }
.sge-lag .sge-lag2 { font-size: 10px; font-weight: 500; }
.sge-dim { opacity: .45; }
/* IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): стили карточки — в graph/SchemeErdCard.vue */
.sge-glyph { font-size: 12px; font-weight: 600; }
.sge-chip { cursor: pointer; }
.sge-chip.sge-hl rect { stroke: var(--sge-hl); stroke-width: 2; stroke-dasharray: none; }
.sge-mono { font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace; font-size: 11px; font-weight: 500; }
.sge-mono-s { font-size: 9px; }
.sge-chiptxt { font-size: 10px; }
.sge-chiphz { font-size: 9px; font-weight: 600; letter-spacing: 0.4px; text-transform: uppercase; }
.sge-leghead { font-size: 12px; font-weight: 700; letter-spacing: 0.6px; text-transform: uppercase; }
.sge-leg { font-size: 12px; }
.sge-note { font-size: 11.5px; }
.sge-tip { position: absolute; z-index: 8; max-width: 320px; padding: 6px 10px; border-radius: 6px; background: var(--surface-overlay, var(--surface-card, #fff)); color: var(--text-color); border: 1px solid var(--surface-border, #cbd5e1); box-shadow: 0 4px 14px rgba(0,0,0,.18); font-size: 12px; pointer-events: none; }
.sge-tip-title { font-weight: 600; margin-bottom: 2px; }
.sge-tip-row { line-height: 1.35; } .sge-tip-k { color: var(--text-color-secondary); } .sge-tip-muted { color: var(--text-color-secondary); font-style: italic; }
</style>
